import React from 'react';
import { IonText } from '@ionic/react';
import useNavigation from '../hooks/useNavigation';
import PlotCard from './PlotCard';

interface IProps {
    plots: any[];
    headerIconOnClickHandler?: Function;
}

const Plots: React.FC<IProps> = (props) => {
    const navigateTo = useNavigation();

    function showSensorData(event: Event, plot: any) {
        event.stopPropagation();
        navigateTo('/sensor-data', { plot: plot, sinceHours: 24 });
    }

    return (
        <>
            {Array.isArray(props.plots) && props.plots.map((plot, index) => <PlotCard headerIconOnClickHandler={props.headerIconOnClickHandler || showSensorData} plot={plot} key={index} />)}
            {(!Array.isArray(props.plots) || props.plots.length === 0) && (
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '48px 24px', gap: '8px' }}>
                    <IonText color="medium" style={{ fontSize: '14px' }}>No plots found</IonText>
                    <IonText color="medium" style={{ fontSize: '13px' }}>Pull to refresh</IonText>
                </div>
            )}
        </>
    );
};

export default Plots;
